import { minLength, maxLength, stringPattern, minItems, stringPatternError } from '../../utils/form-validations';
const portMinLength = 1;
export const defaultFields = { service_name: '', key: '', port: '' };

export const addPlatformUISchema = [
  { id: 1, label: 'Display Name', name: 'service_name', type: 'input', required: true },
  { id: 2, label: 'Key', name: 'key', type: 'input', required: true },
  { id: 3, label: 'Port', name: 'port', type: 'input', required: true },
  // { id: 4, label: 'Types', name: 'types', type: 'select', options: ['TCP', 'UDP'], required: false },
];

export const addPlatformSchema = {
  type: 'object',
  properties: {
    service_name: {
      type: 'string',
      minLength,
      maxLength,
      // pattern: stringPattern,
      // errorMessage: {
      //   pattern: stringPatternError,
      // },
    },
    key: {
      type: 'string',
      minLength,
      maxLength,
      pattern: stringPattern,
      errorMessage: {
        pattern: stringPatternError,
      },
    },
    port: { type: 'number', minimum: 0, maximum: 65535 },
    // types: { type: 'array', minItems, items: [{ type: 'string' }] },
    service_id: { type: 'number' },
    id: { type: 'number' },
  },
  required: ['service_name', 'key', 'port'],
  additionalProperties: true,
};
